import { createSlice } from '@reduxjs/toolkit';

import { IRentalsState } from './interfaces';
import { loadRentalsItem, loadRentalsList } from './actions';

export const rentalsSlice = createSlice({
  name: 'rentals',
  initialState: {
    list: [],
    item: {},
    limit: 20,
    total: 0,
    offset: 0,
  } as IRentalsState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(
      loadRentalsList.fulfilled,
      (state, { payload: { data, total } }) => {
        state.list = data;
        state.total = total;
      }
    );
    builder.addCase(loadRentalsItem.fulfilled, (state, { payload }) => {
      state.item = payload;
    });
  },
});
